import { cn } from "../../lib/utils.js";

/** Shared keyboard ring for rail controls (preview `:focus-visible`). */
export const RAIL_FOCUS =
  "focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[#79d9be]";

/** Fixed hit target for collapsed controls outside the main rail (Super Admin language switcher). */
export const RAIL_COMPACT_HIT = `inline-flex size-10 shrink-0 items-center justify-center rounded-md border-0 bg-transparent text-rail-text transition-[background-color,color] duration-150 ease-in-out hover:bg-white/[0.07] hover:text-rail-active ${RAIL_FOCUS}`;

/** Full-width wrapper that centers a compact hit target on the rail midline. */
export function railCompactRowClassName(className?: string): string {
  return cn("flex w-full justify-center", className);
}

/** Collapse / close control in the rail header. */
export const RAIL_HEADER_CONTROL = `inline-grid w-7 shrink-0 place-items-center rounded-[7px] border-0 bg-transparent text-[#99bfb4] transition-[background-color,color] duration-150 hover:bg-[#264641] hover:text-white ${RAIL_FOCUS}`;

/** Charcoal Forest fill shared by the customer rail, its mobile drawer and the Super Admin console. */
export const CHARCOAL_FOREST_SURFACE =
  "bg-[linear-gradient(180deg,#1c2b2b_0%,#152323_55%,#101b1c_100%)]";

/** Raised mint well for the active workspace icon on the rail card (organization or Super Admin). */
export const RAIL_IDENTITY_ICON_WELL =
  "size-9 rounded-[10px] border-[rgba(166,240,212,0.28)] bg-[linear-gradient(140deg,#5ccba4,#2c7a68)] text-white shadow-[0_6px_16px_rgba(44,122,104,0.35),inset_0_1px_0_rgba(255,255,255,0.22)]";

/** Card fill for the organization card on the rail. */
export const RAIL_CARD = "border border-[rgba(213,255,239,0.1)] bg-white/[0.055]";

/** Thin rail scrollbar. Chromium ignores ::-webkit-scrollbar once scrollbar-color is set. */
export const RAIL_SCROLL =
  "[&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[#3c6357] no-webkit-scrollbar:[scrollbar-width:thin] no-webkit-scrollbar:[scrollbar-color:#3c6357_transparent]";

/**
 * Mint bar on the outer edge of the active row. Inline-start is the screen edge
 * on both the RTL (right) and LTR (left) rail.
 */
export function railActiveIndicatorClassName(compact: boolean): string {
  return cn(
    "pointer-events-none absolute start-0 z-10 w-[3px] rounded-[4px] bg-nav-indicator shadow-[0_0_10px_#55bca655]",
    compact ? "top-[11px] h-[22px]" : "top-[9px] h-[26px]",
  );
}
